export default __webpack_public_path__ + "08fc4e2ccbbce53de2572edab6717e6c.png";